
import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useShrineInteractions } from '@/hooks/use-shrine';
import ShrineContainer from '@/components/shrine/ShrineContainer';
import ShrineContent from '@/components/shrine/ShrineContent';
import ShrineAuth from '@/components/shrine/ShrineAuth';

// Custom hook to encapsulate video shrine state and logic
const useShrineState = () => {
  const { contributeToShrine, totalOfferings, recentOfferings } = useShrineInteractions();
  const [contribution, setContribution] = useState(50);

  const handleContribute = async () => {
    await contributeToShrine(contribution);
  };

  return {
    contribution,
    setContribution,
    handleContribute,
    totalOfferings,
    recentOfferings
  };
};

const Videos = () => {
  const { user } = useAuth();
  const {
    contribution,
    setContribution,
    handleContribute,
    totalOfferings,
    recentOfferings
  } = useShrineState();

  // Use custom background for Videos page
  const containerStyle = {
    backgroundImage: 'url(/TheShrineBG.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  if (!user) {
    return (
      <div className="relative min-h-screen flex items-center justify-center">
        <div className="fixed inset-0" style={containerStyle}>
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
        </div>
        <ShrineAuth />
      </div>
    );
  }

  return (
    <div className="relative min-h-screen flex items-center justify-center">
      <div className="fixed inset-0" style={containerStyle}>
        <div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      </div>
      <ShrineContent
        totalOfferings={totalOfferings}
        contribution={contribution}
        onContributionChange={setContribution}
        onContribute={handleContribute}
        recentOfferings={recentOfferings}
      />
    </div>
  );
};

export default Videos;
